'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002412 from "./presto.-Login-Page-View$$anon$12.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$11() {
  this.b5i = null;
  this.b5a = null;
  this.b5b = false;
  this.b5j = null;
  this.b5k = false;
  this.b5n = null;
  this.b5g = null;
  this.b5h = false;
  this.b5c = null;
  this.b5d = false;
  this.b5e = null;
  this.b5f = false;
  this.b5l = false;
  this.b5m = false;
  this.b5i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b5n = "CompactGroup";
}
export { $c_Lpresto_LoginPageView$$anon$11 as $c_Lpresto_LoginPageView$$anon$11 };
$p = $c_Lpresto_LoginPageView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$11;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$11() {
}
export { $h_Lpresto_LoginPageView$$anon$11 as $h_Lpresto_LoginPageView$$anon$11 };
$h_Lpresto_LoginPageView$$anon$11.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b5i;
});
$p.L = (function() {
  if ((!this.b5b)) {
    this.b5a = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b5b = true;
  }
  return this.b5a;
});
$p.O = (function() {
  if ((!this.b5k)) {
    this.b5j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b5k = true;
  }
  return this.b5j;
});
$p.E = (function() {
  return this.b5n;
});
$p.t = (function() {
  if ((!this.b5h)) {
    this.b5g = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b5h = true;
  }
  return this.b5g;
});
$p.M = (function() {
  if ((!this.b5d)) {
    this.b5c = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b5d = true;
  }
  return this.b5c;
});
$p.Q = (function() {
  if ((!this.b5f)) {
    this.b5e = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002412.$c_Lpresto_LoginPageView$$anon$12();
    this.b5f = true;
  }
  return this.b5e;
});
$p.w = (function() {
  if ((!this.b5m)) {
    this.b5l = false;
    this.b5m = true;
  }
  return this.b5l;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee85) => ((p) => \u03b4scrutinee85.ad6(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_LoginPageView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$11, "presto.LoginPageView$$anon$11", ({
  M2: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$11 as $d_Lpresto_LoginPageView$$anon$11 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$11.js.map
